import React from 'react';

import classNames from 'classnames';

import {useFeature} from 'components/feature';

import s from './shippingMethodsWrapper.scss';

export type PropsType = {
    title: string;
    description: string;
    deliveryPrice: React.JSX.Element | 'Free';
};

/**
 * Shipping Methods Wrapper for shipping methods list
 */
export const ShippingMethodsWrapper: React.FC<PropsType> = ({
    deliveryPrice,
    description,
    title,
}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <>
            <div className={classNames(s.methodWrapper, {[s.methodWrapperFacelift]: isFacelift})}>
                <p className={s.description}>{description}</p>
                <p className={s.method}>{title}&nbsp;Delivery</p>
            </div>
            <p className={s.price}>{deliveryPrice}</p>
        </>
    );
};
